import React, { useState, useEffect, useRef } from 'react';
//import Peer from "peerjs";
import DailyIframe from '@daily-co/daily-js';
import { saveAs } from 'file-saver';
import { useParams, useNavigate } from 'react-router-dom';
import { Breadcrumb, Row, Col, Card, Button, notification, Result } from 'antd';
// import LogoBid from "../assets/img/png/bidlab.png";
// import LogoCiti from "../assets/img/png/citifundation.png";
import VideoCameraOutlined from '@ant-design/icons/VideoCameraOutlined';
import PauseCircleOutlined from '@ant-design/icons/PauseCircleOutlined';
import PlayCircleOutlined from '@ant-design/icons/PlayCircleOutlined';
import DownloadOutlined from '@ant-design/icons/DownloadOutlined';
import AudioOutlined from '@ant-design/icons/AudioOutlined';
import AudioMutedOutlined from '@ant-design/icons/AudioMutedOutlined';
import CloseOutlined from '@ant-design/icons/CloseOutlined';
import CloseCircleOutlined from '@ant-design/icons/CloseCircleOutlined';
import FileImageOutlined from '@ant-design/icons/FileImageOutlined';
//import VideoCameraOutlined from "@ant-design/icons/VideoCameraOutlined";
// import mic from "../../../assets/img/png/mic.png";
// import micoff from "../../../assets/img/png/mic_off.png";
// import cam from "../../../assets/img/png/cam.png";
// import camoff from "../../../assets/img/png/cam_off.png";
import moment from 'moment';
import axios from 'axios';

import './Conference.scss';

// import { returnMailImage } from "../utils/functions";

import { getEventByUrlApi, UpdateEventApi } from '../../../api/event.api';
import { AddVideoApi } from '../../../api/video.api';
import ModalUser from '../../../components/Admin/ModalUser';
import errorpermisos from '../../../assets/img/png/error.png';

import { getAccessTokenApi } from '../../../api/auth';

import { DAILY_API_KEY } from '../../../api/config';

export default function Conference() {
  const [event, setEvent] = useState();
  const [tokendaily, setTokendaily] = useState();

  const [peerId, setPeerId] = useState('');
  const [remotePeerIdValue, setRemotePeerIdValue] = useState('');
  const remoteVideoRef = useRef(null);
  const currentUserVideoRef = useRef(null);
  const videoRef = useRef(null);
  const peerInstance = useRef(null);
  const mediaStreamRef = useRef(null);
  const callFrame = useRef(null);
  const [isJoined, setIsJoined] = useState(false);
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [recordedChunks, setRecordedChunks] = useState([]);
  const [isRecording, setIsRecording] = useState(false);
  const [isPreparing, setIsPreparing] = useState(false);
  const [isStartVideo, setIsStartVideo] = useState(false);
  const [isDownload, setIsDownload] = useState(true);
  const [isInCall, setIsInCall] = useState(false);
  const [calling, setCalling] = useState(false);
  const [isRemoteConnect, setIsRemoteConnect] = useState(false);
  const [videoEnabled, setVideoEnabled] = useState(true);
  const [audioEnabled, setAudioEnabled] = useState(true);
  const [mediaStream, setMediaStream] = useState(null);
  const [recordingUrl, setRecordingUrl] = useState(false);
  const [statusmessage, setStatusmessage] = useState('Iniciar el peritaje');
  //const [peerSave, setPeerSave] = useState(null);
  const [connection, setConnection] = useState(null);
  const [urldaily, setUrldaily] = useState(null);
  const [videoLinks, setVideoLinks] = useState([]); // [{url:string, id:string|number, created:Date}]
  const [clientLocation, setClientLocation] = useState(null);
  const clientLocationRef = useRef(null);

  const canvasRef = useRef(null);
  const { evento } = useParams();

  const [videoClientEnabled, setVideoClientEnabled] = useState(true);
  const [audioClientEnabled, setAudioClientEnabled] = useState(true);
  //const [dataConnection, setDataConnection] = useState(null);

  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [modalTitle, setModalTitle] = useState();

  const [modalContent, setmodalContent] = useState();

  const navigate = useNavigate();

  const token = getAccessTokenApi();

  const recordingIdRef = useRef(null);

  var serverClose = false;

  useEffect(() => {
    //var loadCall = false;
    //console.log(evento);
    getEventByUrlApi(evento, 'Inspector Saferisk').then((response) => {
      setEvent(response.event);
      setTokendaily(response.token);
      //console.log(response.token);
    });
  }, []);

  const call = async (remotePeerId) => {
    console.log(remotePeerId);
    setCalling(true);
    //var getUserMedia = navigator.getUserMedia || navigator.mozGetUserMedia;

    //console.log(getUserMedia);
    try {
      const joinRoom = async () => {
        // 🔥 DESTRUYE si ya existe una instancia previa
        if (callFrame.current) {
          try {
            callFrame.current.destroy();
          } catch (e) {
            console.warn('Error destruyendo instancia previa:', e);
          }
        }

        callFrame.current = DailyIframe.createFrame({
          iframeStyle: {
            position: 'relative',
            width: '100%',
            height: '100%',
            border: '0',
            borderRadius: '10px',
          },
          lang: 'es',
          showParticipantsBar: true,
          showLocalVideo: false,
        });
        console.log(event.roomurl);
        console.log(tokendaily);

        callFrame.current.join({
          url: event.roomurl,
          token: tokendaily,
          startVideoOff: true,
        });
        callFrame.current.on('joined-meeting', () => setIsJoined(true));

        const contenedor = document.getElementById('video-container');
        if (contenedor) contenedor.innerHTML = ''; // limpia iframe previo
        contenedor.appendChild(callFrame.current.iframe());

        // document
        //   .getElementById("video-container")
        //   .appendChild(callFrame.current.iframe());
        setIsInCall(true);
      };

      if (callFrame.current) {
        await callFrame.current.destroy();
      }

      callFrame.current = DailyIframe.createCallObject({
        customLayout: true,
      });

      const joinCall = async () => {
        setStatusmessage('Conectando al servicio...');

        await callFrame.current.join({
          url: event.roomurl,
          token: tokendaily,
        });

        callFrame.current.updateReceiveSettings({
          audio: true,
          video: true,
        });

        await callFrame.current.setLocalVideo(false);
        await callFrame.current.setLocalAudio(true);

        setStatusmessage('Esperando al cliente...');

        // Escuchar evento cuando alguien publica su video
        callFrame.current.on('participant-updated', (ev) => {
          const participant = ev.participant;

          if (!participant.local) {
            setIsInCall(true);
            setIsRemoteConnect(true);
          }

          if (!participant.local && participant.tracks.video.track) {
            // Mostrar el video remoto en nuestro videoRef
            videoRef.current.srcObject = new MediaStream([
              participant.tracks.video.track,
            ]);
            videoRef.current.play();

            // Forzar recepción de audio:
          } else if (!participant.local && !participant.tracks.video.track) {
            videoRef.current.srcObject = null;
          }

          if (!participant.local && participant.tracks.audio.track) {
            const audioTrack = participant.tracks.audio.track;
            const remoteAudio = new Audio();
            remoteAudio.srcObject = new MediaStream([audioTrack]);
            remoteAudio
              .play()
              .catch((e) =>
                console.warn('No se pudo reproducir el audio remoto:', e)
              );
          }
        });

        callFrame.current.on('recording-stopped', async (event1) => {
          console.log(event1);
          const instanceId = recordingIdRef.current;

          if (!instanceId) {
            console.error('No se encontró instanceId de la grabación');
            return;
          }

          // const url = event?.recording?.download_url;
          // if (url) {
          //   setRecordingUrl(url);
          // }
          setIsPreparing(true);
          const res = await axios.get(
            `https://api.daily.co/v1/recordings/${instanceId}/access-link`,
            {
              headers: {
                Authorization: `Bearer ${DAILY_API_KEY}`,
              },
            }
          );
          const url = res.data?.download_link;
          setUrldaily(url);
          // Guardar en lista de enlaces (varios videos por sesión)
          setVideoLinks((prev) => [
            ...prev,
            {
              url,
              id: instanceId || `rec-${Date.now()}`,
              created: new Date().toISOString(),
            },
          ]);
          AddVideoApi(token, { url: url, eventId: event.id });
          setTimeout(() => {
            setRecordingUrl(true);
            setIsPreparing(false);
          }, 25000);

          //setIsRecording(false);
        });

        callFrame.current.on('recording-started', (event2) => {
          recordingIdRef.current = event2.recordingId;
          console.log('Grabación iniciada:', event);
        });

        callFrame.current.on('app-message', (appEvent) => {
          const { data } = appEvent || {};
          if (data?.type === 'client-location') {
            const payload = data.payload || {};
            const nextLocation = {
              lat: payload.lat,
              lon: payload.lon,
              accuracy: payload.accuracy,
              error: payload.error,
              requestId: data.requestId,
              receivedAt: Date.now(),
            };
            clientLocationRef.current = nextLocation;
            setClientLocation(nextLocation);
          }
        });

      };

      joinCall();
      UpdateEventApi(token, { start: moment() }, event.id);
      return () => {
        if (callFrame.current) {
          callFrame.current.leave();
          callFrame.current.destroy();
        }
      };
    } catch (err) {
      console.log(err);
    }
  };

  const startRecording = async () => {
    //if (mediaRecorder) {
    //mediaRecorder.start();
    try {
      await callFrame.current.startRecording();
      setIsRecording(true);
      setIsDownload(false);
      setIsStartVideo(true);
    } catch (err) {
      console.error('Error al iniciar la grabación:', err);
    }
  };

  const stopRecording = async () => {
    // if (mediaRecorder && mediaRecorder.state === "recording") {
    //mediaRecorder.stop();
    try {
      setIsRecording(false);
      await callFrame.current.stopRecording();
      //
    } catch (err) {
      console.error('Error al detener la grabación:', err);
    }
  };

  const handleDownloadLink = (url) => {
    if (!url) return;
    const a = document.createElement('a');
    a.href = url;
    a.download = `grabacion-peritaje-${Date.now()}.mp4`;
    a.click();
  };

  const downloadRecording = async () => {
    const instanceId = recordingIdRef.current;

    if (!instanceId && !urldaily && videoLinks.length === 0) {
      console.error(
        'No se encontró instanceId ni enlaces de grabación disponibles'
      );
      return;
    }

    try {
      // Preferimos la URL más reciente disponible.
      const latestUrl =
        urldaily ||
        (videoLinks.length > 0 ? videoLinks[videoLinks.length - 1].url : null);
      if (latestUrl) {
        setRecordingUrl(latestUrl);
        console.log('URL de descarga lista:', latestUrl);
        handleDownloadLink(latestUrl);
        setIsDownload(true);
      } else {
        console.log('Grabación aún no disponible');
      }
    } catch (err) {
      console.error('Error consultando grabación:', err);
    }
  };

  const toggleVideo = () => {
    if (mediaStream) {
      const videoTrack = mediaStream.getVideoTracks()[0];
      videoTrack.enabled = !videoEnabled;
      setVideoEnabled(!videoEnabled);
    }
  };

  const toggleAudio = () => {
    if (mediaStream) {
      const audioTrack = mediaStream.getAudioTracks()[0];
      audioTrack.enabled = !audioEnabled;
      setAudioEnabled(!audioEnabled);
    }
  };

  const endCall = async () => {
    console.log(isStartVideo);
    console.log(isRemoteConnect);

    if (!isStartVideo && isRemoteConnect) {
      openNotificationWithIcon(
        'error',
        'No se puede finalizar la llamada porque no ha inciado la grabación de un video!'
      );
      return;
    }

    if (isRecording) {
      openNotificationWithIcon(
        'error',
        'No se puede finalizar la llamada porque tiene una grabación en curso, primero detenga la grabación y descargue el archivo!'
      );
      return;
    }

    // if (!isDownload) {
    //   openNotificationWithIcon(
    //     'error',
    //     'No se puede finalizar la llamada porque no ha descargado el video generado!'
    //   );
    //   return;
    // }

    if (callFrame.current) {
      callFrame.current.sendAppMessage(
        {
          type: 'call-ended',
          message: 'La llamada ha sido finalizada por el inspector.',
        },
        '*'
      );
      await callFrame.current.leave();
      await callFrame.current.destroy();
      callFrame.current = null; // Limpieza explícita
      // Aquí puedes agregar lógica adicional post-llamada
      console.log('Llamada finalizada');

      UpdateEventApi(token, { end: moment() }, event.id).then((response) => {
        setIsInCall(false);
        navigate('/user/eventos');
      });
    }
  };

  const captureSnapshot2 = async () => {
    const videoEl = videoRef.current;

    if (!videoEl || videoEl.readyState < 2) {
      alert('El video del cliente no está listo.');
      return;
    }

    const canvas = document.createElement('canvas');
    canvas.width = videoEl.videoWidth;
    canvas.height = videoEl.videoHeight;

    const ctx = canvas.getContext('2d');
    ctx.drawImage(videoEl, 0, 0, canvas.width, canvas.height);

    canvas.toBlob((blob) => {
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `captura-peritaje-${Date.now()}.jpg`;
      a.click();
      URL.revokeObjectURL(url);
    });
  };

  const captureSnapshot = async () => {
    const videoEl = videoRef.current;

    if (!videoEl || videoEl.readyState < 2) {
      alert('El video del cliente no está listo.');
      return;
    }

    const requestClientLocation = async () => {
      const participants = callFrame.current?.participants?.();
      const remoteParticipant = participants
        ? Object.values(participants).find((p) => !p.local)
        : null;
      if (!remoteParticipant) {
        return null;
      }
      const requestId = `loc-${Date.now()}`;
      callFrame.current.sendAppMessage(
        { type: 'request-location', requestId },
        remoteParticipant.session_id
      );
      return requestId;
    };

    const waitForClientLocation = (requestId, timeoutMs = 4000) =>
      new Promise((resolve) => {
        const startedAt = Date.now();
        const intervalId = setInterval(() => {
          const latest = clientLocationRef.current;
          if (latest && latest.requestId === requestId) {
            clearInterval(intervalId);
            resolve(latest);
          } else if (Date.now() - startedAt >= timeoutMs) {
            clearInterval(intervalId);
            resolve(null);
          }
        }, 100);
      });

    const requestId = await requestClientLocation();
    const requestedLocation = requestId
      ? await waitForClientLocation(requestId)
      : null;

    // 🔍 Mejorar resolución con factor de escalado
    const scaleFactor = 3; // Puedes probar con 2 o 3
    const width = videoEl.videoWidth * scaleFactor;
    const height = videoEl.videoHeight * scaleFactor;

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;

    const ctx = canvas.getContext('2d');

    // 🖼️ Dibujar con mejor calidad
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(videoEl, 0, 0, width, height);

    const timestamp = moment().format('YYYY-MM-DD HH:mm:ss');
    const latestLocation = requestedLocation || clientLocationRef.current;
    const lat = latestLocation?.lat;
    const lon = latestLocation?.lon;
    const coordsText =
      lat != null && lon != null
        ? `Lat: ${lat}  Lon: ${lon}`
        : 'Lat/Lon: no disponible';
    const textLines = [`Fecha y hora: ${timestamp}`, coordsText];

    const padding = Math.max(16, Math.round(width * 0.012));
    const fontSize = Math.max(20, Math.round(width * 0.02));
    ctx.font = `${fontSize}px Arial`;
    ctx.textBaseline = 'top';

    const textWidths = textLines.map((line) => ctx.measureText(line).width);
    const boxWidth = Math.max(...textWidths) + padding * 2;
    const boxHeight = textLines.length * fontSize + padding * 2;

    ctx.fillStyle = 'rgba(0, 0, 0, 0.6)';
    ctx.fillRect(padding, height - boxHeight - padding, boxWidth, boxHeight);

    ctx.fillStyle = '#ffffff';
    textLines.forEach((line, index) => {
      ctx.fillText(
        line,
        padding * 2,
        height - boxHeight - padding + padding + index * fontSize
      );
    });

    // 📷 Convertir a blob y descargar
    canvas.toBlob(
      (blob) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `captura-peritaje-${Date.now()}.jpg`;
        a.click();
        URL.revokeObjectURL(url);
      },
      'image/jpeg',
      1 // calidad del JPEG (máximo 1.0)
    );
  };


  const openNotificationWithIcon = (type, text) => {
    notification[type]({
      message: 'Notificación SafeRisk',
      description: text,
      placement: 'bottomRight',
    });
  };

  const toggleClientVideo = () => {
    // const participants = callFrame.current.participants();
    // const remote = Object.values(participants).find((p) => !p.local);
    // if (remote) {
    //   callFrame.current.updateParticipant(remote.session_id, {
    //     setVideo: !videoClientEnabled,
    //   });

    //   if (!videoClientEnabled) {
    //     videoRef.current.srcObject = null; // Limpiar el stream
    //   }

    //   setVideoClientEnabled(!videoClientEnabled);
    // }
    const participants = callFrame.current.participants();
    const remoteParticipant = Object.values(participants).find((p) => !p.local);

    if (remoteParticipant) {
      const sessionId = remoteParticipant.session_id;
      console.log('Remote session_id:', sessionId);
      callFrame.current.sendAppMessage({ type: 'toggle-video' }, sessionId);
      setVideoClientEnabled(!videoClientEnabled);
    }
  };

  const toggleClientAudio = () => {
    // const participants = callFrame.current.participants();
    // const remote = Object.values(participants).find((p) => !p.local);
    // if (remote) {
    //   callFrame.current.updateParticipant(remote.session_id, {
    //     setAudio: !audioClientEnabled,
    //   });
    //   setAudioClientEnabled(!audioClientEnabled);
    // }
    const participants = callFrame.current.participants();
    const remote = Object.values(participants).find((p) => !p.local);

    if (remote) {
      callFrame.current.sendAppMessage(
        { type: 'toggle-client-audio', payload: !audioClientEnabled },
        remote.session_id
      );
      setAudioClientEnabled(!audioClientEnabled);
    }
  };

  const switchClientCamera = () => {
    // const participants = callFrame.current.participants();
    // const remote = Object.values(participants).find((p) => !p.local);
    // if (!remote) return;
    // callFrame.current.updateParticipant(remote.session_id, {
    //   setCamcorderFacingMode: "environment", // o 'user'
    // });
    const participants = callFrame.current.participants();
    const remote = Object.values(participants).find((p) => !p.local);
    if (!remote) return;

    callFrame.current.sendAppMessage(
      { type: 'switch-client-camera', payload: 'environment' }, // o 'user'
      remote.session_id
    );
  };

  return (
    <div className="conference">
      <Breadcrumb style={{ margin: '16px 0' }}>
        <Breadcrumb.Item>Inspector</Breadcrumb.Item>
        <Breadcrumb.Item>
          <a href="/user/eventos">Conferencias</a>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Video llamada</Breadcrumb.Item>
      </Breadcrumb>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
          <Card
            size="small"
            title="Correo"
            headStyle={{ backgroundColor: '#175e92', color: 'white' }}
            bodyStyle={{ fontWeight: 'Bold', fontSize: '16px' }}
          >
            {event ? event.mail : 'No existe la conferencia'}
          </Card>
        </Col>
        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
          <Card
            size="small"
            title="Teléfono móvil"
            headStyle={{ backgroundColor: '#175e92', color: 'white' }}
            bodyStyle={{ fontWeight: 'Bold', fontSize: '16px' }}
          >
            {event ? event.mobil : ''}
          </Card>
        </Col>
        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
          <Card
            size="small"
            title="Código de la conferencia"
            headStyle={{ backgroundColor: '#175e92', color: 'white' }}
            bodyStyle={{ fontWeight: 'Bold', fontSize: '16px' }}
          >
            {event ? event.code : ''}
          </Card>
        </Col>
      </Row>
      <br />
      {!isInCall && (
        <Row gutter={24}>
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={24}
            style={{ textAlign: 'center' }}
          >
            {/* <button onClick={() => call(remotePeerIdValue)}>Call</button> */}
            <Button
              style={{ width: '200px', height: '200px' }}
              shape="circle"
              icon={<VideoCameraOutlined style={{ fontSize: '60px' }} />}
              size="large"
              onClick={() => call(remotePeerIdValue)}
              loading={calling}
            />
          </Col>

          <Col
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={24}
            style={{ textAlign: 'center' }}
          >
            {/* <button onClick={() => call(remotePeerIdValue)}>Call</button> */}
            <h2>{statusmessage}</h2>
          </Col>
        </Row>
      )}
      <Row gutter={24}>
        <Col xs={24} sm={24} md={16} lg={16} xl={16}>
          {/* <button onClick={() => call(remotePeerIdValue)}>Call</button> */}
          <div
            className={
              isInCall
                ? 'video-container-conference bakcground-video-image-conference'
                : 'video-container-conference'
            }
          >
            {/* <video
              ref={remoteVideoRef}
              className="background-video-conference"
            /> */}
            {/* <div
              id="video-container"
              className="background-video-conference"
            ></div> */}
            <video
              ref={videoRef}
              style={{
                width: '100%',
                borderRadius: '8px',
                backgroundColor: videoClientEnabled ? 'transparent' : 'black',
                position: 'absolute',
                top: 0,
                left: 0,
                height: '100%',
                objectFit: 'contain' /* Muestra todo el video sin recortar */,
              }}
              autoPlay
              //muted
              playsInline
            />

            {isInCall && (
              <div className="control-buttons">
                {/* <Button
                  onClick={toggleVideo}
                  type="default"
                  icon={
                    videoEnabled ? <VideoCameraOutlined /> : <CloseOutlined />
                  }
                >
                  {videoEnabled ? "Apagar Video" : "Habilitar Video"}
                </Button> */}
                {/* <button onClick={toggleVideo}>
                  {videoEnabled ? "Disable Video" : "Enable Video"}
                </button> */}
                {/* <Button
                  onClick={toggleAudio}
                  type="default"
                  icon={
                    audioEnabled ? <AudioOutlined /> : <AudioMutedOutlined />
                  }
                >
                  {audioEnabled ? "Silenciar Audio" : "Habilitar Audio"}
                </Button> */}
                {/* <button onClick={toggleAudio}>
                  {audioEnabled ? "Mute Audio" : "Unmute Audio"}
                </button> */}
                {/* <Button
                  onClick={endCall}
                  type="primary"
                  danger
                  icon={<CloseCircleOutlined />}
                >
                  Finalizar llamada
                </Button> */}
                {/* <button onClick={endCall}>End Call</button> */}
              </div>
            )}
          </div>
        </Col>

        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
          {/* <button onClick={() => call(remotePeerIdValue)}>Call</button> */}
          <Row gutter={24}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}></Col>
            {isInCall && (
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                style={{ marginBottom: '10px' }}
              >
                <Button
                  onClick={startRecording}
                  loading={isRecording}
                  type="default"
                  icon={<PlayCircleOutlined />}
                  size="large"
                  style={{ width: '100%' }}
                >
                  Iniciar grabación de video
                </Button>
                {/* <button onClick={startRecording} disabled={isRecording}>
                  Start Recording
                </button> */}
              </Col>
            )}

            {isInCall && (
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                style={{ marginBottom: '10px' }}
              >
                <Button
                  onClick={stopRecording}
                  disabled={!isRecording}
                  type="default"
                  icon={<PauseCircleOutlined />}
                  size="large"
                  style={{ width: '100%' }}
                >
                  Detener grabación de video
                </Button>
                {/* <button onClick={stopRecording} disabled={!isRecording}>
                  Stop Recording
                </button> */}
              </Col>
            )}

            {isInCall && (
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                style={{ marginBottom: '10px' }}
              >
                <Button
                  onClick={downloadRecording}
                  disabled={!recordingUrl}
                  type="default"
                  icon={<DownloadOutlined />}
                  size="large"
                  style={{ width: '100%' }}
                  loading={isPreparing}
                >
                  {isPreparing ? 'Preparando...' : 'Descargar video grabado'}
                </Button>
                {/* <button
                  onClick={downloadRecording}
                  disabled={recordedChunks.length === 0}
                >
                  Download Recording
                </button> */}
              </Col>
            )}
            {isInCall && (
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                style={{ marginBottom: '10px' }}
              >
                <Button
                  onClick={captureSnapshot}
                  //disabled={recordedChunks.length === 0}
                  type="default"
                  icon={<FileImageOutlined />}
                  size="large"
                  style={{ width: '100%' }}
                >
                  Capturar imagen y descargar
                </Button>
                {/* <button
                  onClick={downloadRecording}
                  disabled={recordedChunks.length === 0}
                >
                  Download Recording
                </button> */}
              </Col>
            )}
            {isInCall && (
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                style={{ marginBottom: '10px' }}
              >
                <Button
                  onClick={toggleClientVideo}
                  //disabled={recordedChunks.length === 0}
                  type="default"
                  icon={
                    videoClientEnabled ? (
                      <VideoCameraOutlined />
                    ) : (
                      <CloseOutlined />
                    )
                  }
                  size="large"
                  style={{ width: '100%' }}
                >
                  {videoClientEnabled
                    ? 'Apagar video cliente'
                    : 'Habilitar video cliente'}
                </Button>
                {/* <button
                  onClick={downloadRecording}
                  disabled={recordedChunks.length === 0}
                >
                  Download Recording
                </button> */}
              </Col>
            )}
            {isInCall && (
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                style={{ marginBottom: '10px' }}
              >
                <Button
                  onClick={toggleClientAudio}
                  //disabled={recordedChunks.length === 0}
                  type="default"
                  icon={
                    audioClientEnabled ? (
                      <AudioOutlined />
                    ) : (
                      <AudioMutedOutlined />
                    )
                  }
                  size="large"
                  style={{ width: '100%' }}
                >
                  {audioClientEnabled
                    ? 'Silenciar audio cliente'
                    : 'Habilitar audio cliente'}
                </Button>
                {/* <button
                  onClick={downloadRecording}
                  disabled={recordedChunks.length === 0}
                >
                  Download Recording
                </button> */}
              </Col>
            )}
            {isInCall && (
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                style={{ marginBottom: '10px' }}
              >
                <Button
                  onClick={switchClientCamera}
                  //disabled={recordedChunks.length === 0}
                  type="default"
                  icon={<VideoCameraOutlined />}
                  size="large"
                  style={{ width: '100%' }}
                >
                  Cambiar cámara cliente
                </Button>
                {/* <button
                  onClick={downloadRecording}
                  disabled={recordedChunks.length === 0}
                >
                  Download Recording
                </button> */}
              </Col>
            )}
            {isInCall && (
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                style={{ marginBottom: '10px' }}
              >
                <Button
                  onClick={endCall}
                  //disabled={recordedChunks.length === 0}
                  type="primary"
                  danger
                  icon={<CloseCircleOutlined />}
                  size="large"
                  style={{ width: '100%' }}
                >
                  Finalizar llamada
                </Button>
                {/* <button
                  onClick={downloadRecording}
                  disabled={recordedChunks.length === 0}
                >
                  Download Recording
                </button> */}
              </Col>
            )}
            {/* Render lista de enlaces de descarga de videos Daily */}
            {isInCall && videoLinks.length > 0 && (
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                style={{ marginTop: '20px' }}
              >
                <Card
                  size="small"
                  title="Videos grabados"
                  headStyle={{ backgroundColor: '#175e92', color: 'white' }}
                  bodyStyle={{ fontSize: '14px' }}
                >
                  {videoLinks.map((v, i) => (
                    <div key={v.id} style={{ marginBottom: 8 }}>
                      <Button
                        block
                        icon={<DownloadOutlined />}
                        onClick={() => handleDownloadLink(v.url)}
                      >
                        Descargar video #{i + 1}
                      </Button>
                      {/* <div
                        style={{
                          fontSize: 12,
                          wordBreak: 'break-all',
                          marginTop: 4,
                        }}
                      >
                        <a
                          href={v.url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {v.url}
                        </a>
                      </div> */}
                    </div>
                  ))}
                </Card>
              </Col>
            )}

            <Col
              xs={{ span: 24, offset: 0 }}
              sm={{ span: 24, offset: 0 }}
              md={{ span: 24, offset: 0 }}
              lg={{ span: 20, offset: 2 }}
              xl={{ span: 20, offset: 2 }}
              style={{ minHeight: '500px' }}
            >
              {' '}
              <canvas
                ref={canvasRef}
                className="background-video-conference"
                //style={{ display: "none" }}
              />
            </Col>
          </Row>
        </Col>
      </Row>

      <ModalUser
        title={modalTitle}
        isVisibleModal={isVisibleModal}
        setIsVisibleModal={setIsVisibleModal}
        width={800}
      >
        {modalContent}
      </ModalUser>
    </div>
  );
}
